export default function () {
  return {
    convocatorias: [],
    ediciones: [],
    patrocinadores: [],
    participacionesTipos: []
  }
}
